"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CircleProgressBar = ({ size = 36, progress = 0, strokeWidth = 3, circleOneStroke = 'var(--n-200)', circleTwoStroke = 'var(--n-200)', dataCy = '', textColor = 'var(--n-000)' }) => {
    const center = size / 2;
    const radius = size / 2 - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;
    const [offset, setOffset] = (0, react_1.useState)(circumference);
    const circleRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const progressOffset = ((100 - progress) / 100) * circumference;
        setOffset(progressOffset);
        if (circleRef.current) {
            circleRef.current.setAttribute('style', 'transition: stroke-dashoffset 700ms');
        }
    }, [setOffset, progress, circumference, offset]);
    return (react_1.default.createElement("div", { className: "circle-svg-progress-bar-container", "data-cy": dataCy },
        react_1.default.createElement("svg", { className: "svg d-block ", width: size, height: size },
            react_1.default.createElement("g", { strokeWidth: strokeWidth, fill: "none" },
                react_1.default.createElement("circle", { className: "svg-circle-bg", stroke: circleOneStroke, cx: center, cy: center, r: radius }),
                react_1.default.createElement("circle", { className: "svg-circle", ref: circleRef, stroke: circleTwoStroke, cx: center, cy: center, r: radius, strokeDasharray: circumference, strokeDashoffset: offset }),
                react_1.default.createElement("text", { x: `${center}`, y: `${center}`, transform: "translate(1, 3)", className: "svg-circle-text fw-bold fs-10", fill: textColor, textAnchor: "middle" },
                    progress,
                    "%")))));
};
exports.default = CircleProgressBar;
